import { authorizeUser } from "@metrixorg/websdk";
import { useJwtToken } from "@website/hooks/auth-manager";
import { WebengageLoginType } from "@website/tracking/tracking.types";
import toString from "lodash-es/toString";
import { useCallback, useMemo } from "react";

export const useWebengage: WebengageLoginType = () => {
  const { userPushId, phoneNumber, name, sub } = useJwtToken();

  const login = useCallback(
    (guestUserPhone?: string | number) => {
      const phone = toString(phoneNumber || guestUserPhone);

      authorizeUser(sub);

      if (!window.webengage) {
        setTimeout(login, 1000);
        return;
      }
      userPushId && window.webengage.user.login(userPushId);
      phone && window.webengage.user.setAttribute("we_phone", phone);
      name && window.webengage.user.setAttribute("we_first_name", name);
      phone &&
        window.webengage.user.setAttribute(
          "random-usernumber",
          Number(phone.slice(-1))
        );
    },
    [name, phoneNumber, userPushId]
  );

  return useMemo(() => ({ login }), [login]);
};
